import { Grid } from 'antd';
import type { ReactNode } from 'react';
import { orgPageMaxWidth } from './organisationsUi';

export function OrganisationsPageLayout({ children }: { children: ReactNode }) {
  const screens = Grid.useBreakpoint();
  const sidePadding = screens.md ? 24 : 16;

  return (
    <div
      style={{
        width: '100%',
        maxWidth: orgPageMaxWidth,
        margin: '0 auto',
        padding: `4px ${sidePadding}px 56px`,
        boxSizing: 'border-box',
      }}
    >
      {children}
    </div>
  );
}
